import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ApplyToInvoicePage } from './apply-to-invoice.page';

const routes: Routes = [
  {
    path: '',
    component: ApplyToInvoicePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ApplyToInvoicePageRoutingModule {}
